import React from 'react'
import img from '../background.jpg'
import Products from './Products'
import { useNavigate } from 'react-router-dom'
function Home() {

  const navigate = useNavigate()

  return (
    <>

      <div className="hero">

        <div className="card bg-dark text-black border-0">
          <img src={img} className="card-img" alt="background" height="650px" />

          <div className="card-img-overlay d-flex justify-content-end align-items-center">

            <div className="container ">
              <h5 className="card-title display-3 fw-bolder mb-0">NEW SEASION ARRIVALS</h5>
              <p className="card-text lead fs-2">CHEAK OUT ALL THE TRENDS</p>
              <div className="btn btn-light" onClick={() => navigate('/products')}>Shoping Now</div>
            </div>
          </div>

        </div>

      </div>
      <Products />
    </>
  )
}

export default Home
